export default __webpack_public_path__ + "static/media/SairaExtraCondensed-ExtraBold.e189046c.ttf";